module.exports = __webpack_public_path__ + "static/media/image-default-sdk.447b3e29.png";